import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "../../Spinner/Spinner";
import tick from "../../../Assets/tickImg.png";
import MessageBar, {
  config,
  errorNotify,
  getValueFromLocalStorage,
  localStorageKey,
  successNotify,
  updateValueInLocalStorage,
} from "../../../utils/helper";
import { authorizedPost } from "../../../Config/networkWithToken";
import configuration from "../../../Config/configuration";

const Complete = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const userId = getValueFromLocalStorage(localStorageKey.USERDATA, "_id");
  const userRole = getValueFromLocalStorage(localStorageKey.USERDATA, "role");
  const userData = JSON.parse(localStorage.getItem("userData"));

  const {
    profileCompletionPercentage,
    isActive,
    isRejected,
    isUserVerifyRequested,
    rejectComment,
  } = userData || {};

  const handleOk = async () => {
    setLoading(true);

    if (userRole === "admin" || userRole === "superAdmin") {
      navigate(`/matrimony`);
      return;
    }

    if (profileCompletionPercentage === 100 && isActive) {
      navigate(`/profile/${userId}`);
    }

    if (profileCompletionPercentage === 100 && !isActive) {
      await verifyUserStatus();
    }
    // if (profileCompletionPercentage <= 87.5 && !isActive) {
    //   navigate(`/profile/${userId}`);
    // }

    setLoading(false);
  };

  const verifyUserStatus = async () => {
    try {
      const data = { userId };
      const res = await authorizedPost(
        configuration.apis.userVerify,
        data,
        config,
      );

      if (res?.data?.status) {
        updateValueInLocalStorage(
          localStorageKey.USERDATA,
          "isRejected",
          false,
        );
        updateValueInLocalStorage(
          localStorageKey.USERDATA,
          "isUserVerifyRequested",
          true,
        );
        successNotify(res?.data?.message);
        setTimeout(() => {
          navigate(`/profile-activation`);
        });
      } else {
        errorNotify(res?.data?.message);
        setTimeout(() => {
          navigate(`/profile-activation`);
        }, 2000);
      }
    } catch (error) {
      errorNotify(
        error?.response?.message ||
          "An error occurred while processing the request.",
      );
    }
  };

  const getMessage = () => {
    if (!isActive && !isRejected && !isUserVerifyRequested) {
      return "Your account requires admin approval. Please click the verify button to proceed.";
    }
    if (!isActive && !isRejected && isUserVerifyRequested) {
      return "A verification request has already been submitted. Please await further instructions.";
    }
    if (!isActive && isRejected && !isUserVerifyRequested) {
      return rejectComment
        ? `You must fulfill the following admin comments: ${rejectComment}`
        : "You must fulfill the admin's decline comment.";
    }
    if (!isActive && isRejected && isUserVerifyRequested) {
      return "Please wait until admin verifies and re-approves your account.";
    }
    return "";
  };

  const showReapprovalButton =
    !isActive &&
    ((isRejected && !isUserVerifyRequested) ||
      (!isRejected && !isUserVerifyRequested));

  return (
    <div className="font-helvetica z-50 mt-6 flex min-h-screen w-full justify-center p-8">
      <div className="popup-content rounded-lg text-center">
        <img src={tick} className="mx-auto h-[100px] w-[100px]" alt="Tick" />
        <h2 className="mb-4 text-2xl">Thank You!</h2>
        <p className="mb-4 text-xl">
          Your profile details have been completed successfully.
        </p>

        {/* Conditional message */}
        {profileCompletionPercentage === 100 && !isActive && (
          <p className="mb-4 text-lg text-gray-700">{getMessage()}</p>
        )}

        {/* Conditional button */}
        {(isActive || showReapprovalButton || isUserVerifyRequested) && (
          <button
            type="button"
            className="ok-button rounded bg-textYellow px-4 py-2 text-white"
            onClick={handleOk}
            disabled={loading}
          >
            {loading ? (
              <Spinner />
            ) : isActive ? (
              "OK"
            ) : isRejected && !isUserVerifyRequested ? (
              "Click here for Re-approval"
            ) : (
              "Click Here"
            )}
          </button>
        )}
      </div>
      <MessageBar />
    </div>
  );
};

export default Complete;
